module.exports = __webpack_public_path__ + "img/vuex.44eb506.png";